export const priceTransform = (price, currency, priceSuffix, pricePrefix) => {
  const part = price ? price.toString().split('.') : [];
  const part1 = part[0] && Number(part[0]) ? Number(part[0]) : '0';
  // eslint-disable-next-line
  const part2 = part[1] && part[1].length === 2 ? part[1] : part[1] ? Number(`${part[1]}0`) : '00';
  const currentCurrency = currency ? `<span> ${currency}</span>` : '';
  return `<span class="price-transform">${pricePrefix || ''}${part1}.<sub>${part2 || '00'}${currentCurrency}${priceSuffix || ''}</sub></span>`;
}
